import { NavigationGuard } from 'vue-router'
import { NextQueryItem } from '@/utils/router'
import { store } from '@/store/index'
import i18n from '@/plugins/i18n'
import { ALERT_COLORS } from '@/store/base'
import { axios } from '@/plugins/axios'

export const authMiddleware: NavigationGuard = async (to, from, next) => {
  await store.dispatch('user/fetchUser')
    .then(() => {
      next()
    })
    .catch(error => {
      if (error.response.status === 401) {
        // 元々遷移したかったpathをクエリで渡して、ログイン後に自動的に遷移させる
        const queryNext: NextQueryItem = {
          next: to.path,
        }
        store.commit('base/setAlertMessages', { messages: [i18n.global.t(`error.${error.response.status}`)], color: ALERT_COLORS.danger, persistent: true })
        next({ name: 'Login', query: queryNext })
      }
    })
}

export const guestMiddleware: NavigationGuard = async (to, from, next) => {
  await axios.get('/sanctum/csrf-cookie')
    .catch((error) => {
      console.error('/sanctum/csrf-cookie', error)
    })
    .finally(() => {
      next()
    })
}
